var _path, _rect, _g, _path2, _g2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_3049)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6023 20H5.60229C5.33708 20 5.08272 19.8946 4.89519 19.7071C4.70765 19.5196 4.60229 19.2652 4.60229 19V13C4.60229 12.7348 4.70765 12.4804 4.89519 12.2929C5.08272 12.1054 5.33708 12 5.60229 12H12.6023V5C12.6023 4.73478 12.7077 4.48043 12.8952 4.29289C13.0827 4.10536 13.3371 4 13.6023 4H19.6023C19.8675 4 20.1219 4.10536 20.3094 4.29289C20.4969 4.48043 20.6023 4.73478 20.6023 5V12H27.6023C27.8675 12 28.1219 12.1054 28.3094 12.2929C28.4969 12.4804 28.6023 12.7348 28.6023 13V19C28.6023 19.2652 28.4969 19.5196 28.3094 19.7071C28.1219 19.8946 27.8675 20 27.6023 20H20.6023V27C20.6023 27.2652 20.4969 27.5196 20.3094 27.7071C20.1219 27.8946 19.8675 28 19.6023 28H13.6023C13.3371 28 13.0827 27.8946 12.8952 27.7071C12.7077 27.5196 12.6023 27.2652 12.6023 27V20Z",
    fill: "#FF7A72",
    stroke: "#FF7A72",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1509_3049",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: -5,
    width: 23,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.9783,
    y: -4.27393,
    width: 2.30713,
    height: 33.575,
    transform: "rotate(38.3056 21.9783 -4.27393)",
    fill: "#FF928B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1509_3049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6023 20H5.60229C5.33708 20 5.08272 19.8946 4.89519 19.7071C4.70765 19.5196 4.60229 19.2652 4.60229 19V13C4.60229 12.7348 4.70765 12.4804 4.89519 12.2929C5.08272 12.1054 5.33708 12 5.60229 12H12.6023V5C12.6023 4.73478 12.7077 4.48043 12.8952 4.29289C13.0827 4.10536 13.3371 4 13.6023 4H19.6023C19.8675 4 20.1219 4.10536 20.3094 4.29289C20.4969 4.48043 20.6023 4.73478 20.6023 5V12H27.6023C27.8675 12 28.1219 12.1054 28.3094 12.2929C28.4969 12.4804 28.6023 12.7348 28.6023 13V19C28.6023 19.2652 28.4969 19.5196 28.3094 19.7071C28.1219 19.8946 27.8675 20 27.6023 20H20.6023V27C20.6023 27.2652 20.4969 27.5196 20.3094 27.7071C20.1219 27.8946 19.8675 28 19.6023 28H13.6023C13.3371 28 13.0827 27.8946 12.8952 27.7071C12.7077 27.5196 12.6023 27.2652 12.6023 27V20Z",
    fill: "#FF8882",
    stroke: "#FF8882",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1509_3049",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 19,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4443 1.85229L24.2547 3.28238L8.50569 23.2201L6.62043 21.923L22.4443 1.85229Z",
    fill: "#FF928B"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1509_3049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6023 20.0002H5.60229C5.33708 20.0002 5.08272 19.8949 4.89519 19.7074C4.70765 19.5198 4.60229 19.2655 4.60229 19.0002V13.0002C4.60229 12.735 4.70765 12.4807 4.89519 12.2931C5.08272 12.1056 5.33708 12.0002 5.60229 12.0002H12.6023V5.00024C12.6023 4.73503 12.7077 4.48067 12.8952 4.29314C13.0827 4.1056 13.3371 4.00024 13.6023 4.00024H19.6023C19.8675 4.00024 20.1219 4.1056 20.3094 4.29314C20.4969 4.48067 20.6023 4.73503 20.6023 5.00024V12.0002H27.6023C27.8675 12.0002 28.1219 12.1056 28.3094 12.2931C28.4969 12.4807 28.6023 12.735 28.6023 13.0002V19.0002C28.6023 19.2655 28.4969 19.5198 28.3094 19.7074C28.1219 19.8949 27.8675 20.0002 27.6023 20.0002H20.6023V27.0002C20.6023 27.2655 20.4969 27.5198 20.3094 27.7074C20.1219 27.8949 19.8675 28.0002 19.6023 28.0002H13.6023C13.3371 28.0002 13.0827 27.8949 12.8952 27.7074C12.7077 27.5198 12.6023 27.2655 12.6023 27.0002V20.0002Z",
    fill: "#FF8882",
    stroke: "#FF8882",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6022 20H5.60223C5.33702 20 5.08266 19.8946 4.89513 19.7071C4.70759 19.5196 4.60223 19.2652 4.60223 19V13C4.60223 12.7348 4.70759 12.4804 4.89513 12.2929C5.08266 12.1054 5.33702 12 5.60223 12H12.6022V5C12.6022 4.73478 12.7076 4.48043 12.8951 4.29289C13.0827 4.10536 13.337 4 13.6022 4H19.6022C19.8675 4 20.1218 4.10536 20.3093 4.29289C20.4969 4.48043 20.6022 4.73478 20.6022 5V12H27.6022C27.8675 12 28.1218 12.1054 28.3093 12.2929C28.4969 12.4804 28.6022 12.7348 28.6022 13V19C28.6022 19.2652 28.4969 19.5196 28.3093 19.7071C28.1218 19.8946 27.8675 20 27.6022 20H20.6022V27C20.6022 27.2652 20.4969 27.5196 20.3093 27.7071C20.1218 27.8946 19.8675 28 19.6022 28H13.6022C13.337 28 13.0827 27.8946 12.8951 27.7071C12.7076 27.5196 12.6022 27.2652 12.6022 27V20Z",
    stroke: "#FF6960",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_3049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.602295)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.107a1bcf7fb38ee96cef106c1689b941.svg";
export { ForwardRef as ReactComponent };